export default __webpack_public_path__ + "static/media/7c4471f663ee3dca4afb83a73ee19234.jpg";